// Presentation only: this helper never adds a platform or changes its identity.
// Apply only to standard rosters, after authorization/eligibility filtering.
// Do not use on user-selected or metric-ranked sequences.
const compact = (value) => String(value || "").toLowerCase().replace(/[^a-z0-9]/g, "");
export const isYahooPlatform = (value) => ["yahoo", "yahoodsp"].includes(compact(value));
export function placeYahooAfterAmazon(items, getKey = (item) => item) {
  const entries = [...items];
  const amazon = entries.find((item) => ["amazon", "amazonads", "amazondsp"].includes(compact(getKey(item))));
  if (amazon === undefined) return entries;
  const yahoo = entries.filter((item) => isYahooPlatform(getKey(item)));
  if (!yahoo.length) return entries;
  const rest = entries.filter((item) => !isYahooPlatform(getKey(item)));
  rest.splice(rest.indexOf(amazon) + 1, 0, ...yahoo);
  return rest;
}
